import { useSelector } from 'react-redux';
import { useIsTrialActive } from '../../../../hooks/use-is-trial-active';
import Global from '../../../../store/global-selectors';
import { BillingPlanIds } from '../../../../enums/billing-plan-ids';

/**
 * Custom hook to determine if freemium components should be visible
 * based on user's billing plan and trial status
 * @returns {object} Object containing freemium visibility information
 */
export const useFreemiumVisibility = () => {
  const isTrialActive = useIsTrialActive();
  const { billingPlanId } = useSelector(Global.selectSellerSubscriptionPlanInfo) ?? {};

  const hasFreemiumPlan = billingPlanId === BillingPlanIds.Free2025Q2;
  const shouldShowFreemiumComponents = hasFreemiumPlan && !isTrialActive;

  return {
    hasFreemiumPlan,
    shouldShowFreemiumComponents,
    isTrialActive,
    billingPlanId,
  };
};
